import { render, staticRenderFns } from "./PrivateFilesOnContactPage.vue?vue&type=template&id=1c619256&"
import script from "./PrivateFilesOnContactPage.vue?vue&type=script&lang=js&"
export * from "./PrivateFilesOnContactPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateFilesOnContactPage.vue?vue&type=style&index=0&id=1c619256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports